exports.shouldUpdateScroll = () => [0, 0];

// Mobile browsers sometimes restore a stale scroll position on a fresh load,
// leaving the page parked under the masthead. Start at the top unless this is
// back/forward navigation or the URL asks for an anchor.
exports.onInitialClientRender = () => {
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (window.location.hash || (nav && nav.type === 'back_forward')) return;
    window.scrollTo(0, 0);
  } catch (e) { /* ignore */ }
};
